import { omit } from 'lodash';
import { ParsedUrlQuery } from 'querystring';
// Types
import { NextRouter } from 'next/router';

// to open user sign up modal
const SIGN_UP = 'sign-up';

type ModalType = 'user' | 'athlete' | 'organization' | 'content-creator';

export const getSignUpModalQuery = (modalType: ModalType): string => {
  return `${SIGN_UP}=${modalType}`;
};

export const getQueryWithoutQueryParams = (
  query: ParsedUrlQuery
): ParsedUrlQuery => {
  const queryCopy = { ...query };
  const queryKeys = [SIGN_UP, 'signIn', 'redirectPath', 'passwordResetToken'];

  queryKeys.forEach((key) => {
    delete queryCopy[key];
  });

  return queryCopy;
};

export const isSignUpModalOpen = (
  queryParams: ParsedUrlQuery,
  modalType: ModalType
): boolean => {
  return queryParams[SIGN_UP] === modalType;
};

export const isChooseSignUpPathModalOpen = (
  queryParams: ParsedUrlQuery
): boolean => {
  return queryParams[SIGN_UP] === '';
};

export const isSignUpV2ModalOpen = (queryParams: ParsedUrlQuery): boolean => {
  return queryParams[SIGN_UP] === '' || queryParams.signUp === '';
};

export const hasRedirectPathInQuery = (query: ParsedUrlQuery): boolean => {
  const redirectPath = query.redirectPath;
  if (!redirectPath) return false;
  const value = Array.isArray(redirectPath) ? redirectPath[0] : redirectPath;
  return Boolean(value && String(value).trim());
};

export const removeSignUpQueryParam = (
  router: NextRouter
): Promise<boolean> | undefined => {
  if (isSignUpV2ModalOpen(router.query)) {
    const newQuery = omit(router.query, ['sign-up', 'signUp']);
    return router.replace(
      { pathname: router.pathname, query: newQuery },
      undefined,
      {
        shallow: true,
      }
    );
  }
  return undefined;
};
